import SiteStasApi from '../../api/siteStas.api.js'
import moment from 'moment'
const state = {
	typeData: [{
		name: '浏览量(PV)',
		code: 'pv_count',
		type: 'pv_count',
		act: true,
	}, {
		name: '访客数(UV)',
		code: 'visitor_count',
		type: 'visitor_count',
		act: false,
	},{
		name: 'IP数',
		code: 'ip_count',
		type: 'ip_count',
		act: false,
	},{
		name: '跳出率',
		code: 'bounce_ratio',
		type: 'bounce_ratio',
		act: false,
	}, {
		name: '平均访问时长',
		code: 'avg_visit_time',
		type: 'avg_visit_time',
		act: false,
	}, {
		name: '转化次数',
		code: 'trans_count',
		type: 'trans_count',
		act: false,
	},
	//  {
	// 	name: '其他',
	// 	code: 'more',
	// 	type: 'more',
	// 	act: false,
	// 	child: [{
	// 		name: 'IP数',
	// 		code: 'ip_count'
	// 	},
	// 	{
	// 		name: '跳出率',
	// 		code: 'bounce_ratio'
	// 	},
	// 	{
	// 		name: '平均访问时长',
	// 		code: 'avg_visit_time'
	// 	},
	// 	{
	// 		name: '转化次数',
	// 		code: 'trans_count'
	// 	}
	// 	]
	// }
	],
	dateData: [{
		name: '今日数据',
		code: 'today',
		act: true,
	},
	{
		name: '昨天数据',
		code: 'yesterday',
		act: false,
	},
	{
		name: '最近7天',
		code: 'week',
		act: false,
	},
	{
		name: '最近30天',
		code: 'month',
		act: false,
	},
	],
	stasAccountInfo: {},
	imgCodeData: {},
	curProjId: '',
	datePickerData: {
		oneDay: moment().format('YYYY-MM-DD')
	},
	recentStasData: [],
	todayStasData: [],
	yesterdayStasData: [],
	curType: 'pv_count',
	accountData: {
		site: '',
		domain: '',
		account: ''
	},
	flowData: {},
	siteCount: 0,
	errAccountInfo: '',
	searchWordData: [],
	stasCodeIsChange: false
}

const getters = {
	reduceStas: (state) => (date, type) => {
		if (state[date].length === 0) {
			return 0
		}
		return state[date][0][type] || 0
	},
	getErrTips: state => {
		switch (state.errAccountInfo) {
		case '项目没有绑定域名':
			return {
				info: '小主，系统检测到您还没有绑定域名，暂无网站统计数据',
				btnName: '立即绑定',
				jumpCur: 'domain'
			}
		case '用户没绑定百度统计账号':
			return {
				info: '小主，系统检测到您还没有绑定百度统计账号，<br/>暂无网站统计数据',
				btnName: '立即添加',
				jumpCur: 'statistics'
			}
		default:
			return {
				info: '小主，系统检测到您的百度账号还未创建当前站点，<br/>请先在百度后台创建站点',
				btnName: '立即创建',
				jumpCur: 'jumpBaidu'
			}
		}
	},
	getXAxisData: state => {
		let arr = []
		if (state.datePickerData.oneDay) {
			for (let i = 0; i < 24; i++) {
				i < 10 ? arr.push(`0${i}:00`) : arr.push(`${i}:00`)

			}
			return arr
		} else {
			let startDay = state.datePickerData.startDay
			let endDay = state.datePickerData.endDay
			let handleDate = function (startDay, endDay) {
				if (moment(startDay).isBefore(endDay)) {
					arr.push(startDay)
					let day = startDay
					handleDate(moment(day).add(1, 'days').format('YYYY-MM-DD'), endDay)
				} else {
					return arr
				}
			}
			handleDate(startDay, endDay)
			return arr
		}
	},
	getSeriesData: (state, getters) => {
		let arr = []
		if (state.recentStasData.length > 0) {
			state.recentStasData.forEach(item => {
				let data = item[state.curType] || 0
				arr.push(data)
			})
		} else {
			for (let i = 0; i < getters.getXAxisData.length; i++) {
				arr[i] = 0
			}
		}
		return arr
	},
	getSeriesName: state => {
		let curType = state.typeData.find(item => item.type === state.curType)
		return curType.name
	}
}

const mutations = {
	modifyDateDataAct(state, code) {
		state.dateData.forEach(item => {
			if (item.code === code) {
				item.act = true
			} else {
				item.act = false
			}
		})
	},
	setSearchWordData(state, data) {
		state.searchWordData = data
	},
	setErrAccountInfo(state, data) {
		state.errAccountInfo = data
	},
	setFlowData(state, data) {
		state.flowData = data
	},
	setSiteCount(state, data) {
		state.siteCount = data
	},
	delectSiteCount(state, num) {
		state.siteCount -= num
	},
	setImgCodeData(state, data) {
		state.imgCodeData = data
	},
	setAccountData(state, data) {
		state.accountData = data
	},
	setCurType(state, data) {
		state.curType = data
	},
	setCurProjId(state, data) {
		state.curProjId = data
	},
	setDataPickerData(state, data) {
		state.datePickerData = data
	},
	setRecentStasData(state, data) {
		state.recentStasData = data
	},
	setTodayStasData(state, data) {
		state.todayStasData = data
	},

	setYesterdayStasData(state, data) {
		state.yesterdayStasData = data
	},

	setStasAccountInfo(state, data) {
		state.stasAccountInfo = data
	},
	setScriptInitialValue(state, data) {
		state.scriptInitialValue = data
	},
	setStasCodeIsChange(state, data) {
		state.stasCodeIsChange = data
	}

}

const actions = {

	bindingCode(context, data) {
		return SiteStasApi.bindingCode(data)
	},
	getBaiduAccount(context, params) {
		return SiteStasApi.getBaiduAccount(params)
	},
	verifyImgCode(context, data) {
		return SiteStasApi.verifyImgCode(data)
	},
	// 百度统计api
	bindPreLogin(context, data) {
		return SiteStasApi.preLogin(data)
	},
	getSiteAccount({
		state
	}, curProjId) {
		return new Promise((resolve, reject) => {
			SiteStasApi.getSiteRelation({
				projectId: curProjId
			}).then(res => {
				if (res.data.isSuccess) {
					resolve(res.data.data)
				} else {
					reject(res.data.message)
				}
			}, err => {
				reject(err)
			})
		})
	},
	getSiteDaily({
		state
	}, params) {
		return new Promise((resolve, reject) => {
			SiteStasApi.getDailyAmount(params).then(res => {
				if (res.data.isSuccess) {
					resolve(res.data.data)
				} else {
					reject('获取站点信息失败')
				}
			}, err => {
				reject(err)
			})
		})
	},
	getSiteRelation({
		state,
		commit,
		dispatch
	}) {
		commit('setRecentStasData', [])
		commit('setTodayStasData', [])
		commit('setYesterdayStasData', [])
		commit('setFlowData', {})
		commit('setErrAccountInfo', '')
		return new Promise((resolve, reject) => {
			SiteStasApi.getSiteRelation({
				projectId: state.curProjId,
				user_token: state.token
			}).then(res => {
				if (res.data.isSuccess) {
					commit('setAccountData', res.data.data)
					let yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD')
					let today = moment().format('YYYY-MM-DD')
					dispatch('getDaily', {
						startDay: today,
						endDay: today
					})
					dispatch('getDaily', {
						startDay: yesterday,
						endDay: yesterday
					})
					dispatch('getSearchWord')
					resolve(res.data.data)
				} else {
					commit('setAccountData', {
						site: '',
						domain: '',
						account: ''
					})
					reject(res.data.message)
				}
			}, err => {
				commit('setRecentStasData', [])
				commit('setTodayStasData', [])
				commit('setYesterdayStasData', [])
				reject(err)
			})
		})
	},
	getRealtime({
		state,
		dispatch,
		commit
	}) {
		if (!state.accountData.account) {
			commit('setRecentStasData', [])
			return
		}
		let params = {
			account: state.accountData.account,
			siteId: state.accountData.site,
			oneDay: state.datePickerData.oneDay
		}
		SiteStasApi.getRealtime(params).then(res => {
			let data = res.data.data.reverse(),
				length = data.length

			function handleData(listData, length) {
				listData[length] = {}
				if (length < 24) {
					handleData(listData, listData.length)
				}
			}
			if (length < 24) {
				handleData(data, length)
			}
			console.log(data)
			commit('setRecentStasData', data)
		}, err => {
			commit('setRecentStasData', [])
		})
	},
	getDaily({
		state,
		commit,
		dispatch
	}, params) {
		if (!state.accountData.account) {
			commit('setRecentStasData', [])
			commit('setTodayStasData', [])
			commit('setYesterdayStasData', [])
			return
		}
		let yesterday = moment().subtract(1, 'days').format('YYYY-MM-DD')
		let today = moment().format('YYYY-MM-DD')
		let dataOpt = {
			account: state.accountData.account,
			siteId: state.accountData.site,
			startDay: (params && params.startDay) || state.datePickerData.startDay,
			endDay: (params && params.endDay) || state.datePickerData.endDay
		}
		SiteStasApi.getDaily(dataOpt).then(res => {
			if (params && params.startDay && today === params.startDay) {
				commit('setTodayStasData', res.data.data)
			} else if (params && params.startDay && yesterday === params.startDay) {
				commit('setYesterdayStasData', res.data.data)
			} else {
				commit('setRecentStasData', res.data.data.reverse())
			}
		}, err => {
			if (params && params.startDay && today === params.startDay) {
				commit('setTodayStasData', [])
			} else if (params && params.startDay && yesterday === params.startDay) {
				commit('setYesterdayStasData', [])
			} else {
				commit('setRecentStasData', [])
			}
		})
	},
	getSearchWord({
		state,
		commit,
		dispatch
	}) {
		commit('setSearchWordData', [])
		// let params = {
		// 	account: '311125238681448448',
		// 	siteId: '11745238',
		//     startDay: '2019-04-01',
		//     endDay: '2019-04-09'
		// }
		let params = {
			account: state.accountData.account,
			siteId: state.accountData.site,
			startDay: state.datePickerData.startDay || state.datePickerData.oneDay,
			endDay: state.datePickerData.endDay || state.datePickerData.oneDay
		}
		SiteStasApi.getSearchWord(params).then(res => {
			if (res.data.isSuccess) {
				commit('setSearchWordData', res.data.data)
			}
		}, err => {
			console.log(err)
		})
	},
	getFtpInfo(context, data) {
		return SiteStasApi.getFtpInfo(data)
	},

}

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions
}
